<template>
  <ul class="menu-nav">
    <template v-if="isInsuranceAgent">
      <router-link
        to="/insurance-agent/dashboard"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-layers"></i>
            <span class="menu-text">Insurance agent dashboard</span>
          </a>
        </li>
      </router-link>

      <router-link
        to="/insurance-agent/patients"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-user"></i>
            <span class="menu-text">Patients</span>
          </a>
        </li>
      </router-link>

      <router-link
        to="/insurance-agent/payment-info"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-safe"></i>
            <span class="menu-text">Payment Information</span>
          </a>
        </li>
      </router-link>

      <!-- Calendario de insurance oculto por ahora.
      <router-link
        v-if="$can('index', 'appointment')"
        to="/insurance/calendario"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-calendar"></i>
            <span class="menu-text">Insurance calendar</span>
          </a>
        </li>
      </router-link>
      -->

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
      >
        <a 
          :href="bookingUrl" 
          target="_blank"
          rel="noopener noreferrer"
          class="menu-link"
        >
          <i class="menu-icon flaticon2-calendar"></i>
          <span class="menu-text">Appointment for patients</span>
        </a>
      </li>
    </template>

    <template v-else-if="isAdminAgent">
      <router-link
        to="/admin-agent/dashboard"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-user"></i>
            <span class="menu-text">Admin agent dashboard</span>
          </a>
        </li>
      </router-link>
    </template>

    <template v-else-if="isMember">
      <router-link
        to="/member-dashboard"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-layers"></i>
            <span class="menu-text">My Plan Dashboard</span>
          </a>
        </li>
      </router-link>
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="{ 'menu-item-active': $route.path === '/member-add-plan' }">
        <a href="#" class="menu-link" @click.prevent="navigateToMemberAddPlan">
          <i class="menu-icon flaticon2-plus"></i>
          <span class="menu-text">Add new plan</span>
        </a>
      </li>
    </template>

    <template v-else-if="isAgentPlan">
      <router-link
        to="/agent-plan-dashboard"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-user"></i>
            <span class="menu-text">Agent Plan Dashboard</span>
          </a>
        </li>
      </router-link>

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="{ 'menu-item-active': $route.path === '/agent-plan/add-member' }">
        <a href="#" class="menu-link" @click.prevent="navigateToAddMember">
          <i class="menu-icon flaticon2-plus"></i>
          <span class="menu-text">Add Member</span>
        </a>
      </li>

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="{ 'menu-item-active': $route.path === '/agent-plan/members' }">
        <a href="#" class="menu-link" @click.prevent="navigateToMembers">
          <i class="menu-icon flaticon2-list-2"></i>
          <span class="menu-text">Members List</span>
        </a>
      </li>
    </template>

    <template v-else>
      <router-link to="/dashboard-all" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-layers"></i>
            <span class="menu-text">Dashboard total</span>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-architecture-and-city"></i>
            <span class="menu-text">Dashboard Cash</span>
          </a>
        </li>
      </router-link>

      <router-link
        to="/insurance-admin/dashboard"
        v-if="$can('read', 'insuranceAdminAgentDashboard')"
        v-slot="{ href, navigate, isActive, isExactActive }">
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-user"></i>
            <span class="menu-text">Dashboard admin agents</span>
          </a>
        </li>
      </router-link>

      <Admin></Admin>
      <Appointment></Appointment>
      <!-- Calendario de efectivo oculto por ahora.
      <Calendario></Calendario>
      -->
      <Patient></Patient>
      <OfficeVisit></OfficeVisit>
      <AdminData></AdminData>
      <CashAccount></CashAccount>
      <WeightLossInventoryMenu program-context="normal" />

      <li class="menu-section">
        <h4 class="menu-text">Insurance</h4>
      </li>

      <router-link
        to="/dashboard-insurance"
        v-slot="{ href, navigate, isActive, isExactActive }">
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-architecture-and-city"></i>
            <span class="menu-text">Dashboard insurance</span>
          </a>
        </li>
      </router-link>

      <InsuranceAdmin></InsuranceAdmin>
      <InsuranceAppointment></InsuranceAppointment>
      <!-- Calendario de insurance oculto por ahora.
      <InsuranceCalendario></InsuranceCalendario>
      -->
      <InsurancePatient></InsurancePatient>
      <CreateAgent></CreateAgent>
      <InsuranceOfficeVisit></InsuranceOfficeVisit>
      <InsuranceCashAccount></InsuranceCashAccount>
      <WeightLossInventoryMenu program-context="insurance" />

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
      >
        <a
          href="https://insurance.verification.eyeclinic.solutions/login"
          target="_blank"
          rel="noopener noreferrer"
          class="menu-link"
        >
          <i class="menu-icon flaticon2-checking"></i>
          <span class="menu-text">Insurance Verification</span>
        </a>
      </li>
    </template>
  </ul>
</template>

<script>
import Admin from './components/Admin.vue'
import InsuranceAdmin from './components/InsuranceAdmin.vue'
import AdminData from './components/AdminData.vue'
import Appointment from './components/Appointment.vue'
// import Calendario from './components/Calendario.vue'
import InsuranceAppointment from './components/InsuranceAppointment.vue'
// import InsuranceCalendario from './components/InsuranceCalendario.vue'
import Patient from './components/Patient.vue'
import InsurancePatient from './components/InsurancePatient.vue'
import CreateAgent from './components/CreateAgent.vue'
import OfficeVisit from './components/OfficeVisit.vue'
import InsuranceOfficeVisit from './components/InsuranceOfficeVisit.vue'
import CashAccount from './components/CashAccount.vue'
import InsuranceCashAccount from './components/InsuranceCashAccount.vue'
import WeightLossInventoryMenu from './components/WeightLossInventoryMenu.vue'
import { INSURANCE_AGENT_BOOKING_URL } from '@/view/pages/insuranceAgent/bookingRedirect'
export default {
  name: 'KTMenu',
  components: {
    Admin,
    InsuranceAdmin,
    InsuranceAppointment,
    // InsuranceCalendario,
    Patient,
    Appointment,
    // Calendario,
    OfficeVisit,
    CashAccount,
    AdminData,
    InsurancePatient,
    CreateAgent,
    InsuranceOfficeVisit,
    InsuranceCashAccount,
    WeightLossInventoryMenu,
  },
  data() {
    return {
      roleChangedCounter: 0,
      bookingUrl: INSURANCE_AGENT_BOOKING_URL,
    }
  },
  mounted() {
    window.addEventListener('role-changed', this.onRoleChanged)
  },
  beforeDestroy() {
    window.removeEventListener('role-changed', this.onRoleChanged)
  },
  computed: {
    isInsuranceAgent() {
      // Make this computed reactive to role switches done in localStorage.
      const roleVersion = this.roleChangedCounter
      const storedUser = localStorage.getItem('userData')
      if (!storedUser) return false
      try {
        const parsed = JSON.parse(storedUser)
        const roles = parsed?.roles || []
        const currentRoleId = Array.isArray(roles) ? roles?.[0]?.id : null
        return Number(currentRoleId) === 7 && roleVersion >= 0
      } catch (error) {
        return false
      }
    },
    isAdminAgent() {
      const roleVersion = this.roleChangedCounter
      const storedUser = localStorage.getItem('userData')
      if (!storedUser) return false
      try {
        const parsed = JSON.parse(storedUser)
        const roles = parsed?.roles || []
        const currentRoleId = Array.isArray(roles) ? roles?.[0]?.id : null
        return Number(currentRoleId) === 8 && roleVersion >= 0
      } catch (error) {
        return false
      }
    },
    isMember() {
      const roleVersion = this.roleChangedCounter
      const storedUser = localStorage.getItem('userData')
      if (!storedUser) return false
      try {
        const parsed = JSON.parse(storedUser)
        const roles = parsed?.roles || []
        const currentRoleId = Array.isArray(roles) ? roles?.[0]?.id : null
        return Number(currentRoleId) === 10 && roleVersion >= 0
      } catch (error) {
        return false
      }
    },
    isAgentPlan() {
      const roleVersion = this.roleChangedCounter
      const storedUser = localStorage.getItem('userData')
      if (!storedUser) return false
      try {
        const parsed = JSON.parse(storedUser)
        const roles = parsed?.roles || []
        const currentRoleId = Array.isArray(roles) ? roles?.[0]?.id : null
        return Number(currentRoleId) === 9 && roleVersion >= 0
      } catch (error) {
        return false
      }
    },
  },
  methods: {
    onRoleChanged() {
      this.roleChangedCounter++
    },
    navigateToAddMember() {
      this.$router.push({ name: 'agent-plan-add-member' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err)
        }
      })
    },
    navigateToMembers() {
      this.$router.push({ name: 'agent-plan-members' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err)
        }
      })
    },
    navigateToMemberAddPlan() {
      this.$router.push({ name: 'member-add-plan' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err)
        }
      })
    },
  },
}

</script>
